var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "ele"
    }
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('reports.selectReport')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportid),
      expression: "reportid"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reportname"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.snowFlakeReportList = [];
        _vm.totalPage = 0;
        _vm.showHistoricalReport = false;
        _vm.generateReportStatus = false;
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.selectReport')))]), _vm._v(" "), _vm._l((_vm.snowFlakeMasterReportList), function(report) {
    return _c('option', {
      domProps: {
        "value": report.reportid
      }
    }, [_vm._v(_vm._s(report.reportname))])
  })], 2)]), _vm._v(" "), (_vm.reportid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ReportErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.fromDate')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    on: {
      "change": function($event) {
        _vm.snowFlakeReportList = [];
        _vm.totalPage = 0;
        _vm.showHistoricalReport = false;
        _vm.generateReportStatus = false;
      }
    },
    model: {
      value: (_vm.transactionfromdate),
      callback: function($$v) {
        _vm.transactionfromdate = $$v
      },
      expression: "transactionfromdate"
    }
  })], 1), _vm._v(" "), (_vm.transactionfromdate == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.fromDateErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 datepicker"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.toDate')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    on: {
      "change": function($event) {
        _vm.snowFlakeReportList = [];
        _vm.totalPage = 0;
        _vm.showHistoricalReport = false;
        _vm.generateReportStatus = false;
      }
    },
    model: {
      value: (_vm.transactiontodate),
      callback: function($$v) {
        _vm.transactiontodate = $$v
      },
      expression: "transactiontodate"
    }
  })], 1), _vm._v(" "), (_vm.transactiontodate == null) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.toDateErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.onSearchSnowFlakeReports();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("   " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.reset')))]), _vm._v(" "), (_vm.generateReportStatus !== 'Processing') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.onGenerateHistoricalReports()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" " + _vm._s(_vm.$t('lpnmaster.table.generateBtn')))]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Processing') ? _c('button', {
    staticClass: "btn btn-basic",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('historicalReports.processing')))]) : _vm._e()])])])])])], 1)], 1)]), _vm._v(" "), (_vm.showHistoricalReport) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('historicalReports.historicalReports')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.reportName')))])]), _vm._v(" "), (_vm.user_type != 'client_user') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.clientName')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'warehouse_user') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.warehouse')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdBy')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.table.action')))])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "cardreporttabletr"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.reportArr[_vm.currentGenerationreportId]))]), _vm._v(" "), (_vm.user_type != 'client_user') ? _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.getClientname()))]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'warehouse_user') ? _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.getWarehousename()))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.dateFormatFRT(_vm.createdDate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [(_vm.generateReportStatus === 'Download') ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v(_vm._s(_vm.$t('common.success')))]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Processing') ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v(" " + _vm._s(_vm.$t('historicalReports.processing')))]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Failed') ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(_vm._s(_vm.$t('orders.failed')))]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Pending') ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v(_vm._s(_vm.$t('common.pending')))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    attrs: {
      "scope": "row"
    }
  }, [(_vm.generateReportStatus === 'Download') ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onDownloadHistoricalReports(_vm.generatedReportId)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Processing') ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Failed') ? _c('span', [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e(), _vm._v(" "), (_vm.generateReportStatus === 'Pending') ? _c('span', [_c('i', {
    staticClass: "fa fa-times"
  })]) : _vm._e()])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('historicalReports.requestedHistoricalReports')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.reportName')))])]), _vm._v(" "), (_vm.user_type != 'client_user') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.clientName')))])]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'warehouse_user') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.warehouse')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.createdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.fromDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.toDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.size')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.status')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.table.action')))])])])]), _vm._v(" "), _c('tbody', [_c('loader', {
    attrs: {
      "isLoading": _vm.loaderForRequestedReports
    }
  }), _vm._v(" "), (_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": " 16",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.snowFlakeReportList), function(data, index) {
    return (_vm.resultCount != 0) ? _c('tr', {
      staticClass: "cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")((data.reportname))))]), _vm._v(" "), (_vm.user_type != 'client_user') ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.getClientname()))]) : _vm._e(), _vm._v(" "), (_vm.user_type != 'warehouse_user') ? _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.getWarehousename()))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.dateFormatFRT(data.createddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.dateFormatFRT(data.fromdate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(_vm.dateFormatFRT(data.todate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [(data.status === 'success') ? _c('span', [_vm._v("\n                      " + _vm._s(_vm.sizeFormat(data.filesize, data.filesizeunit)) + "\n                    ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [(data.status === 'success') ? _c('span', {
      staticClass: "badge badge-pill badge-success"
    }, [_vm._v(_vm._s(_vm.$t('common.success')))]) : (data.status === 'created') ? _c('span', {
      staticClass: "badge badge-pill badge-danger"
    }, [_vm._v(_vm._s(_vm.$t('orders.failed')))]) : (data.status === 'pending') ? _c('span', {
      staticClass: "badge badge-pill badge-secondary"
    }, [_vm._v(_vm._s(_vm.$t('common.pending')))]) : (data.status === 'notfound') ? _c('span', {
      staticClass: "badge badge-pill badge-danger"
    }, [_vm._v(_vm._s(_vm.$t('editedjson.notFound')))]) : _c('span', {
      staticClass: "badge badge-pill badge-warning"
    }, [_vm._v(_vm._s(data.status))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [(data.status === 'success') ? _c('button', {
      on: {
        "click": function($event) {
          _vm.onDownloadHistoricalReports(data.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), (data.status !== 'success') ? _c('span', [_vm._v("-")]) : _vm._e()])]) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalPage,
      "per-page": _vm.limit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4611d65d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4611d65d","hasScoped":true}!./src/views/components/historicalreport/historicalreport.component.html
// module id = 2121
// module chunks = 0